export default __webpack_public_path__ + "static/media/icon-ajout-cata-permanent.42f23c6f.svg";